import React from "react";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ListOutlinedIcon from "@material-ui/icons/ListOutlined";
import { FbSidebarItem } from "@flexibees/core";
import { Link, useRouteMatch } from "react-router-dom";


const menuItems = [
  {
    name: "Dashboard",
    icon: HomeOutlinedIcon,
    path: "/dashboard",
  },
    {
    name: "All Jobs",
    icon: ListOutlinedIcon,
    path: "/jobs",
  },
  {
    name: "All Candidates",
    icon: PeopleAltOutlinedIcon,
    path: "/candidates",
  },
 {
    name:"MP Launches",
    icon: ListOutlinedIcon,
    path: "/mpLaunches",
  },
];

export default function MenuItems() {
  const [activeMenuIndex, setactiveMenuIndex] = React.useState(
    menuItems.findIndex((mItem) => window.location.href.includes(mItem.path))
  );
  const [activeMenu, setActiveMenu] = React.useState(
    activeMenuIndex < 0 ? "" : menuItems[activeMenuIndex].name
  );

  React.useEffect(() => {
    setactiveMenuIndex(
      menuItems.findIndex((mItem) => window.location.href.includes(mItem.path))
    );
  }, [window.location.href]);

  React.useEffect(() => {
    setActiveMenu(activeMenuIndex < 0 ? "" : menuItems[activeMenuIndex].name);
  }, [activeMenuIndex]);

  const changeActiveMenu = (menu) => {
    setActiveMenu(menu);
   
  };

  const { path } = useRouteMatch();
  return (
    <div>
      {menuItems.map((item, index) => {
        return (
          <Link to={`${path}${item.path}`} style={{ textDecoration: "none" }} key={item.name}>
            <FbSidebarItem
              name={item.name}
              icon={item.icon}
              key={item.name}
              activeMenu={activeMenu}
              changeActiveMenu={changeActiveMenu}
            />
          </Link>
        );
      })}
    </div>
  );
}
